import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	lineHeight,
	minWidth,
	Text,
} from '@calm-web/design-system';

export const Wrapper = styled.div`
	color: ${palette('white')};
	text-align: center;
`;

export const Title = styled(Text).attrs({
	size: FontSizes.xl,
	weight: FontWeights.Medium,
	noMargin: true,
	el: 'h1',
})`
	margin-bottom: 8px;

	${minWidth('tablet')} {
		${fontSize(FontSizes['4xl'])};
		${lineHeight(FontSizes['4xl'])};
		${fontWeight(FontWeights.Regular)};
	}
`;

export const Description = styled(Text).attrs({
	size: FontSizes.base,
	weight: FontWeights.Regular,
	el: 'h2',
})`
	margin-bottom: 24px;
`;
